import moment from 'moment'

import timezoneAbbr from './timezoneAbbr'

const formatTime = (date: string | Date): string => moment(date).format('h:mma')

const formatDateRange = (start: string | Date, end: string | Date): string => {
  return `${formatTime(start)} - ${formatTime(end)} ${timezoneAbbr()}`
}

export default formatDateRange
